(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[131],{

/***/ 1232:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/index.en",
      function () {
        return __webpack_require__(9031);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ strings; }
/* harmony export */ });
const strings = {
    "en": {
        Title: "String Tension Calculator",
        Description: "Find the right string gauge for your guitar or bass to achieve the perfect tension.",
        Scale: "Scale",
        Note: "Note",
        Gauge: "Gauge",
        Tension: "Tension",
        Frequency: "Frequency",
        Guitar: "Guitar",
        Bass: "Bass",
        CopyLink: "Copy Link",
        Copied: "Copied!",
        SingleScale: "Single Scale",
        Multiscale: "Multiscale",
        SelectYourScale: "Select Your Scale",
        AddString: "Add String",
        "HelpBox.StringTension": "String Tension",
        "HelpBox.ColorOfTension": 'The color of the tension value in the table shows how light (or heavy)\n    the string is, with "yellow" being lighter and "red" being heavier.',
        "HelpBox.TypicallyForGuitars": "Typically for guitars:",
        "HelpBox.TypicallyForBasses": "And for basses",
        "HelpBox.LightTension": "light tension",
        "HelpBox.RegularTension": "regular tension",
        "HelpBox.HeavyTension": "heavy tension",
        "HelpBox.ValuesMayVary": "Although these values may vary depending on the instrument technical\n    characteristics.",
        "HelpBox.Lighter": "LIGHTER",
        "HelpBox.Heavier": "HEAVIER"
    },
    "ua": {
        Title: "Калькулятор натягу струн",
        Description: "Знайдіть правильний калібр струн для своєї гітари або бас-гітари для досягнення ідеального натягу.",
        Scale: "Мензура",
        Note: "Нота",
        Gauge: "Калібр",
        Tension: "Натяг",
        Frequency: "Частота",
        Guitar: "Гітара",
        Bass: "Бас",
        CopyLink: "Скопіювати посилання",
        Copied: "Скопійовано!",
        SingleScale: "Звичайна мензура",
        Multiscale: "Мультимензура",
        SelectYourScale: "Виберіть мензуру",
        AddString: "Додати струну",
        "HelpBox.StringTension": "Натяг струн",
        "HelpBox.ColorOfTension": "Колір цифри натягу струни в таблиці показує наскільки сильно натягнута струна. Жовтий колір означає, що струна натягнута слабо, червоний — сильно.",
        "HelpBox.TypicallyForGuitars": "Звичайні значення для гітар:",
        "HelpBox.TypicallyForBasses": "Tа для басів",
        "HelpBox.LightTension": "легкий натяг",
        "HelpBox.RegularTension": "звичайний натяг",
        "HelpBox.HeavyTension": "сильний натяг",
        "HelpBox.ValuesMayVary": "Дані значення можуть помітно відрізнятися залежно від інструменту та його технічних характеристик",
        "HelpBox.Lighter": "ЛЕГШЕ",
        "HelpBox.Heavier": "СИЛЬНІШЕ"
    },
    "ru": {
        Title: "Калькулятор натяжения струн",
        Description: "Найдите правильный калибр струн для своей гитары или бас-гитары, чтобы достичь идеального натяжения.",
        Scale: "Мензура",
        Note: "Нота",
        Gauge: "Калибр",
        Tension: "Натяжение",
        Frequency: "Частота",
        Guitar: "Гитара",
        Bass: "Бас",
        CopyLink: "Скопировать ссылку",
        Copied: "Скопировано!",
        SingleScale: "Обычная мензура",
        Multiscale: "Мультимензура",
        SelectYourScale: "Выберите мензуру",
        AddString: "Добавить струну",
        "HelpBox.StringTension": "Натяжение струн",
        "HelpBox.ColorOfTension": "Цвет цифры натяжение струны в таблице показывает как сильно струна натянута. Желтый цвет означает что струна натянута слабо, а красный что сильно",
        "HelpBox.TypicallyForGuitars": "Обычные значения для гитар:",
        "HelpBox.TypicallyForBasses": "Для басов",
        "HelpBox.LightTension": "легкое натяжение",
        "HelpBox.RegularTension": "обычное натяжение",
        "HelpBox.HeavyTension": "сильное натяжение",
        "HelpBox.ValuesMayVary": "Данные значение могут заметно оличатся в зависимости от инструмента и его технических характеристик",
        "HelpBox.Lighter": "ЛЕГЧЕ",
        "HelpBox.Heavier": "СИЛЬНЕЕ"
    }
};


/***/ }),

/***/ 5204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Sample; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1834);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ui_Shimmer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9554);



/* harmony default export */ __webpack_exports__["Z"] = (next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(201), __webpack_require__.e(185), __webpack_require__.e(798), __webpack_require__.e(631)]).then(__webpack_require__.bind(__webpack_require__, 9631)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9631)
            ]
    },
    loading: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_Shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {}),
    ssr: false
}));
const Sample = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(201), __webpack_require__.e(185), __webpack_require__.e(798), __webpack_require__.e(631), __webpack_require__.e(742)]).then(__webpack_require__.bind(__webpack_require__, 6742)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6742)
            ]
    },
    loading: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_Shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {}),
    ssr: false
});


/***/ }),

/***/ 9554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Shimmer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(959);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6851);



const styles = {
    spinner: {
        width: "40px",
        height: "40px",
        border: "5px solid rgba(0, 0, 0, 0.1)",
        borderTopColor: _styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.button */ .DM.button,
        borderRadius: "50%",
        animation: "spin 1s linear infinite"
    },
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100px",
        padding: "20px"
    }
};
const Shimmer = ()=>{
    const spinnerStyle = {
        width: "40px",
        height: "40px",
        border: "5px solid rgba(0, 0, 0, 0.1)",
        borderTopColor: _styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.button */ .DM.button,
        borderRadius: "50%",
        animation: "spin 1s linear infinite"
    };
    const keyframes = "\n        @keyframes spin {\n          0% {\n            transform: rotate(0deg);\n          }\n          100% {\n            transform: rotate(360deg);\n          }\n        }\n      ";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: styles.container,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: spinnerStyle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: keyframes
            })
        ]
    });
};


/***/ }),

/***/ 6851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ COLORS; },
/* harmony export */   "LI": function() { return /* binding */ button; },
/* harmony export */   "nZ": function() { return /* binding */ selector; },
/* harmony export */   "nb": function() { return /* binding */ FONT; }
/* harmony export */ });
const FONT = "Fira Sans Extra Condensed,sans-serif";
const COLORS = {
    lightBackground: "#2a2a33",
    buttonBackground: "#383845",
    arrow: "#fff",
    lightGrayText: "#6a6a7c",
    button: "#663df3",
    border: "#292b33",
    primaryHue: "hsl(204, 100%, 50%)"
};
const button = {
    borderRadius: "29px",
    background: COLORS.button,
    boxShadow: "inset 3px 3px rgb(114, 74, 244), 0 0 2px rgb(0, 0, 0)",
    border: "0",
    minHeight: "39px",
    fontFamily: FONT,
    lineHeight: "35px",
    fontSize: "16px",
    color: "white",
    cursor: "pointer"
};
const selector = {
    appearance: "none",
    backgroundColor: COLORS.lightBackground,
    color: "white",
    padding: "10px",
    border: "0",
    minHeight: "40px",
    borderRadius: "3px",
    backgroundImage: "url(/dropdown.png)",
    backgroundPosition: "right",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    fontFamily: FONT,
    fontSize: "15px",
    width: "100%"
};


/***/ }),

/***/ 6408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(959);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3886);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ts_pattern__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7749);
/* harmony import */ var _src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7179);





const config = {
    project: {},
    chat: {},
    footer: {
        component: undefined
    },
    sidebar: {
        toggleButton: true
    },
    nextThemes: {
        forcedTheme: "dark"
    },
    // primaryHue: { dark: 4, light: 4 },
    darkMode: true,
    editLink: {
        component: undefined
    },
    feedback: {
        content: undefined
    },
    i18n: [
        {
            locale: "en",
            text: "English"
        },
        {
            locale: "ua",
            text: "Ukrainian (українська)"
        },
        {
            locale: "ru",
            text: "Russian (русский)"
        }
    ],
    head: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=G-7RT4L8C5YF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\nwindow.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('js', new Date());\n\ngtag('config', 'G-7RT4L8C5YF');\n"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                async: true,
                src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1374017065120638",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://fonts.googleapis.com/css?family=Fira+Sans+Extra+Condensed",
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico",
                type: "image/x-icon"
            })
        ]
    }),
    logo: ()=>{
        const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
        const locale = router.locale;
        const title = (0,ts_pattern__WEBPACK_IMPORTED_MODULE_3__/* .match */ .EQ)(locale).with("en", ()=>"String Tension Calculator").with("ru", ()=>"Калькулятор Натяжения Струн").with("ua", ()=>"Калькулятор Натягу Струн").with(ts_pattern__WEBPACK_IMPORTED_MODULE_3__.P.any, ()=>"String Tension Calculator").exhaustive();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/logo_header.png",
                    style: {
                        width: "35px",
                        height: "42px"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    style: {
                        marginLeft: "20px",
                        fontFamily: "Fira Sans Extra Condensed,sans-serif",
                        fontSize: "24px",
                        fontWeight: "bold",
                        lineHeight: "28px"
                    },
                    children: title
                })
            ]
        });
    },
    themeSwitch: {
        component: null
    },
    search: {
        component: undefined
    },
    // search: { placeholder: "Search..." },
    navigation: {
        prev: false,
        next: false
    },
    // banner: { text: "MEOW" }, // support ukraine?
    docsRepositoryBase: "https://github.com/aaronabramov/string-calc",
    useNextSeoProps: ()=>{
        const { route , locale  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
        // deduplication of all `q=sontheusnathoesu` urls to avoid
        // over-indexing
        const canonical = (0,ts_pattern__WEBPACK_IMPORTED_MODULE_3__/* .match */ .EQ)(route).with("/index.en", ()=>"https://www.stringtensioncalculator.com").with("/index.ru", ()=>"https://www.stringtensioncalculator.com/ru/").with("/index.ua", ()=>"https://www.stringtensioncalculator.com/ua/").with(ts_pattern__WEBPACK_IMPORTED_MODULE_3__.P.any, ()=>undefined).exhaustive();
        const ogImage = (0,ts_pattern__WEBPACK_IMPORTED_MODULE_3__/* .match */ .EQ)(locale).with("ru", ()=>"/og-ru.jpeg").with("ua", ()=>"/og-ua.jpeg").with("en", ()=>"/og-en.jpeg").with(ts_pattern__WEBPACK_IMPORTED_MODULE_3__.P.any, ()=>"/og-en.jpeg").exhaustive();
        const localizedStrings = (0,ts_pattern__WEBPACK_IMPORTED_MODULE_3__/* .match */ .EQ)(locale).with("ua", ()=>_src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__/* .strings.ua */ .j.ua).with("ru", ()=>_src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__/* .strings.ru */ .j.ru).with("en", ()=>_src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__/* .strings.en */ .j.en).with(ts_pattern__WEBPACK_IMPORTED_MODULE_3__.P.any, ()=>_src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__/* .strings.en */ .j.en).exhaustive();
        return {
            canonical,
            titleTemplate: "%s",
            description: localizedStrings.Description,
            openGraph: {
                images: [
                    {
                        url: ogImage,
                        width: 2424,
                        height: 1269,
                        alt: localizedStrings.Title,
                        type: "image/jpeg"
                    }
                ]
            }
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (config);


/***/ }),

/***/ 9031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var nextra_setup_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7664);
/* harmony import */ var nextra_theme_docs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9227);
/* harmony import */ var _vercel_path0_theme_config_tsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6408);
/* harmony import */ var nextra_theme_docs_style_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1324);
/* harmony import */ var nextra_theme_docs_style_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(nextra_theme_docs_style_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var nextra_mdx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6736);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6484);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _src_calc__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5204);





const __nextraPageOptions = {
    MDXContent,
    pageOpts: {
        "filePath": "pages/index.en.mdx",
        "route": "/",
        "frontMatter": {
            "title": "String Tension Calculator"
        },
        "headings": [],
        "timestamp": 1684445074000,
        "pageMap": [
            {
                "kind": "Meta",
                "locale": "en",
                "data": {
                    "index": {
                        "title": "String Tension Calculator",
                        "theme": {
                            "breadcrumb": false,
                            "sidebar": true
                        }
                    },
                    "what-is-guitar-string-tension": {
                        "title": "What is guitar string tension?",
                        "theme": {
                            "breadcrumb": false,
                            "sidebar": true
                        }
                    },
                    "contact": {
                        "title": "Contact ↗",
                        "type": "page",
                        "href": "https://x.com/boujeepossum",
                        "newWindow": true
                    }
                }
            },
            {
                "kind": "MdxPage",
                "name": "index",
                "route": "/",
                "locale": "en",
                "frontMatter": {
                    "title": "String Tension Calculator"
                }
            },
            {
                "kind": "MdxPage",
                "name": "what-is-guitar-string-tension",
                "route": "/what-is-guitar-string-tension",
                "locale": "en"
            }
        ],
        "flexsearch": {
            "codeblocks": true
        },
        "title": "String Tension Calculator"
    },
    pageNextRoute: "/index.en",
    nextraLayout: nextra_theme_docs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP,
    themeConfig: _vercel_path0_theme_config_tsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
};
/*@jsxRuntime automatic @jsxImportSource react*/ 


function _createMdxContent(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                config: {
                    syncUrl: true
                }
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
        ]
    });
}
function MDXContent() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { wrapper: MDXLayout  } = Object.assign({}, (0,nextra_mdx__WEBPACK_IMPORTED_MODULE_7__/* .useMDXComponents */ .ah)(), props.components);
    return MDXLayout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
if (false) {}
if (false) {}
/* harmony default export */ __webpack_exports__["default"] = ((0,nextra_setup_page__WEBPACK_IMPORTED_MODULE_1__/* .setupNextraPage */ .j)(__nextraPageOptions));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,722,888,179], function() { return __webpack_exec__(1232); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);